<template>
    <ot-section v-bind="$attrs" :theme="$otTheme" section>
        <ot-row-group :theme="$otTheme" :code="code">
            <ot-icon :theme="$otTheme" icon="apple" v-ot-bind="$otColors">
                <span>iOS</span>
            </ot-icon>
            <ot-icon :theme="$otTheme" icon="android" :ot-bind="$otColors">
                <span>Android</span>
            </ot-icon>
            <ot-icon :theme="$otTheme" :url="url">
                <span>Baidu</span>
            </ot-icon>
        </ot-row-group>
    </ot-section>
</template>

<script>
export default {
    otDefaultColors() {
        return {
            normal: [ 'def-f' ],
        };
    },
    data() {
        return {
            url: 'https://ss0.bdstatic.com/5aV1bjqh_Q23odCf/static/superman/img/logo_top_86d58ae1.png',
            code: decodeURIComponent(`%3Ctemplate%3E%0A%20%20%20%20%3Cot-section%20section%3E%0A%20%20%20%20%20%20%20%20%3Cot-row-group%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-icon%20icon%3D%22apple%22%20v-ot-bind%3D%22%24otColors%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cspan%3EiOS%3C%2Fspan%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fot-icon%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-icon%20icon%3D%22android%22%20%3Aot-bind%3D%22%24otColors%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cspan%3EAndroid%3C%2Fspan%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fot-icon%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-icon%20%3Aurl%3D%22url%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cspan%3EBaidu%3C%2Fspan%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fot-icon%3E%0A%20%20%20%20%20%20%20%20%3C%2Fot-row-group%3E%0A%20%20%20%20%3C%2Fot-section%3E%0A%3C%2Ftemplate%3E%0A%0A%3Cscript%3E%0Aexport%20default%20%7B%0A%20%20%20%20otDefaultColors()%20%7B%0A%20%20%20%20%20%20%20%20return%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20normal%3A%20%5B%20'def-f'%20%5D%2C%0A%20%20%20%20%20%20%20%20%7D%3B%0A%20%20%20%20%7D%2C%0A%20%20%20%20data()%20%7B%0A%20%20%20%20%20%20%20%20return%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20url%3A%20'https%3A%2F%2Fss0.bdstatic.com%2F5aV1bjqh_Q23odCf%2Fstatic%2Fsuperman%2Fimg%2Flogo_top_86d58ae1.png'%2C%0A%20%20%20%20%20%20%20%20%7D%3B%0A%20%20%20%20%7D%2C%0A%7D%3B%0A%3C%2Fscript%3E`),
        };
    },
};
</script>
